// Web Crypto API — AES-256-GCM client-side encryption
// Master password NEVER leaves the browser.

function bytesToB64(bytes) {
    let bin = "";
    for (const b of bytes) bin += String.fromCharCode(b);
    return btoa(bin);
}
function b64ToBytes(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return arr;
}

async function deriveKey(masterPassword, saltBytes) {
    const enc = new TextEncoder();
    const baseKey = await crypto.subtle.importKey(
        "raw",
        enc.encode(masterPassword),
        { name: "PBKDF2" },
        false,
        ["deriveKey"],
    );
    return crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: saltBytes,
            iterations: 250_000,
            hash: "SHA-256",
        },
        baseKey,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt", "decrypt"],
    );
}

// Encrypt plaintext string → { ciphertext, iv, salt } (all base64)
export async function encryptText(plaintext, masterPassword) {
    const salt = crypto.getRandomValues(new Uint8Array(16));
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await deriveKey(masterPassword, salt);
    const enc = new TextEncoder();
    const cipherBuf = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        key,
        enc.encode(plaintext),
    );
    return {
        ciphertext: bytesToB64(new Uint8Array(cipherBuf)),
        iv: bytesToB64(iv),
        salt: bytesToB64(salt),
    };
}

// Decrypt { ciphertext, iv, salt } (base64) → plaintext string
export async function decryptText({ ciphertext, iv, salt }, masterPassword) {
    const saltBytes = b64ToBytes(salt);
    const ivBytes = b64ToBytes(iv);
    const cipherBytes = b64ToBytes(ciphertext);
    const key = await deriveKey(masterPassword, saltBytes);
    const plainBuf = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: ivBytes },
        key,
        cipherBytes,
    );
    return new TextDecoder().decode(plainBuf);
}

// Simple verifier: try to decrypt one existing item to confirm master password
export async function tryUnlock(items, masterPassword) {
    if (!items || items.length === 0) return true; // nothing to verify yet
    try {
        await decryptText(items[0], masterPassword);
        return true;
    } catch {
        return false;
    }
}
